// @flow

import React from 'react';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import './ViewAllLink.scss';

type Props = {
  linkText?: string,
  onClickViewAll: () => void
}
export class ViewAllLink extends React.Component<Props> {
  onClickViewAll = () => {
    this.props.onClickViewAll();
  }

  render() {
    const { linkText = 'viewAllLink.text' } = this.props;
    return (
      <a className="view-all-link" onClick={this.onClickViewAll}>
        <L10nMessage id={linkText} />
        <span className="view-all-link__icon icon-chevron-right" />
      </a>
    );
  }
}

export default ViewAllLink;
